// extracted by mini-css-extract-plugin
export var quillEditor = "_n7-1";
export var variable = "_n7-0";